<template>
  <div class="banner border-radius layout dashboard__layout" v-if="banners">
    <slider class="border-radius" ref="slider" :options="options" @slide="slide" @tap="onTap" @init="onInit" v-if="banners.length > 1">
      <slideritem v-for="(item, index) in banners" :key="index">
        <img class="banner__img" :src="item.img" @click="clickBanner(item)"/>
      </slideritem>
    </slider>
    <img v-else class="banner__img" :src="banners.img" @click="clickBanner(banners)"/>
    <div class="banner__navigation bg-dark-linear d-flex align-items-center justify-content-end" v-if="banners.length > 1">
      <div class="banner__navigation-previous d-flex align-items-center justify-content-center mr-2" @click="$refs.slider.$emit('slidePre')">
        <i class="icon-arrow-left"></i>
      </div>
      <div class="banner__navigation-next d-flex align-items-center justify-content-center" @click="$refs.slider.$emit('slideNext')">
        <i class="icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ActionMixin from "./ActionMixin";
import { slider, slideritem } from 'vue-concise-slider'

export default {
  name: "Banner",
  components: {
    slider,
    slideritem
  },
  mixins: [ActionMixin],
  data: () => ({
    currentIndex: 1,
    autoPagingTime: 6000,
    options: {
        pagination: false,
        currentPage: 0,
        autoplay: 6000,
        loop: true,
        loopedSlides: 1,
        slidesToScroll: 1,
        timingFunction: "ease",
        speed: 400,
      }
  }),
  computed: {
    ...mapGetters("account", {
      lang: "displayLanguage",
      plan: "shopPlan"
    }),
    ...mapGetters("dashboard", {
      bannerData: "banner",
      loadingDashboard: "loading"
    }),
    banners() {
      if (!this.bannerData?.length) return false;
      
      const length = this.bannerData.length;
      const defaultLang = "en";
      const bannerList = [];
      
      for (let i = 0; i < length; i++) {
        const data = this.bannerData[i];
        const img = !data.img[this.lang] ? data.img[defaultLang] : data.img[this.lang];
        const action =  !data.action[this.lang] ? data.action[defaultLang] : data.action[this.lang];
        const filter = { settings: data.settings, img, action };
        filter.settings[this.plan] && bannerList.push(filter);
      }

      if (bannerList.length == 1) return bannerList[0];
      
      return bannerList;
    },
    currentBanner() {
      return this.banners[Math.abs(this.currentIndex) % this.banners.length];
    },
    bannerDynamicClass() {
      return {
        "loading skeleton-light-grey-200": this.loadingDashboard
      };
    }
  },
    methods: {
    clickPrevious() {
      this.$refs.slider && this.$refs.slider.$emit('slidePre')
    },
    clickNext() {
      this.$refs.slider && this.$refs.slider.$emit('slideNext')
    },
    clickBanner(banner) {
      this.doAction(banner.action);
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  cursor: pointer;

  &:hover {
    @include shadow-hover;
    .banner__navigation {
      opacity: 1;
      transition: all 0.1s ease-in-out;
    }
  }
  
  &.loading {
    height: 212px;
  }

  &__navigation {
    opacity: 0;
    border-radius: 3px;
    z-index: 3;
    &-previous, &-next {
      width: 24px;
      height: 24px;
      border-radius: 3px;
      background-color: $light2;
      cursor: pointer;
      &:hover {
        background-color: $textDarkModeHigh;
      }
    }
    position: absolute;
    padding: 16px;
    bottom: 0px;
    width: 100%;
    height: 56px;
  }
  &__img {
    display: block;
    width: 100%;
    flex: 0 0 auto; 
    filter: drop-shadow(0px 4px 31px rgba(0, 0, 0, 0.04)) drop-shadow(0px 1.6711px 12.9511px rgba(0, 0, 0, 0.0287542)) drop-shadow(0px 0.893452px 6.92426px rgba(0, 0, 0, 0.0238443)) drop-shadow(0px 0.500862px 3.88168px rgba(0, 0, 0, 0.02)) drop-shadow(0px 0.266004px 2.06153px rgba(0, 0, 0, 0.0161557)) drop-shadow(0px 0.11069px 0.85785px rgba(0, 0, 0, 0.0112458));
  }
}
</style>
